var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-col h-40 md:h-auto relative"},_vm._l((_vm.usersList),function(user){return _c('router-link',{key:user.id,attrs:{"to":{
      name: 'admin-users-detail-details',
      params: { id: user.id },
      hash: '#details',
    },"active-class":"active-class-admin "}},[_c('div',{staticClass:"cursor-pointer p-1 hover:bg-my-blue-primary hover:text-white"},[_c('span',{staticClass:"block"},[_c('b',[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))])]),_c('span',[_vm._v(_vm._s(user.email))])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }